var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"share-with-facebook-modal","classes":['modal-window'],"transition":"scale","scrollable":"","adaptive":"","width":"800px","height":"auto"}},[_c('div',{staticClass:"modal-container"},[_c('share-with-facebook')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }